export const smartRemindersEnglish = {
  EMPTY: '—',
  MODULE: 'Smart reminders',
  RULES: 'Reminder rules',
  MESSAGES: 'Messages',
  ALL: 'All',
  ALL_RULES: 'All rules',
  RULE_NAME: 'Rule name',
  CONDITION: 'Trigger condition',
  RECIPIENT: 'Recipient',
  LAST_TRIGGER: 'Last triggered',
  STATUS: 'Status',
  ACTIONS: 'Actions',
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  RULE_SEARCH: 'Search rule name or condition',
  SCENE: 'Scenario',
  QUERY: 'Search',
  RESET: 'Reset',
  REFRESH: 'Refresh',
  RETRY: 'Retry',
  RULES_NOTE:
    'Rules are defined by the system. New rules are disabled by default and can be enabled or disabled with the switch.',
  NO_RULES: 'No reminder rules. New rules will be disabled by default.',
  NO_MATCH: 'No matching rules',
  DETAILS: 'Rule details',
  VIEW_MESSAGES: 'View messages',
  SWITCH_HINT: 'Disabling stops new reminders and retains historical messages.',
  ADMIN_ONLY: 'Only administrators can enable or disable rules.',
  RULE_SWITCH: '{name}: enable or disable rule',
  ENABLED_SUCCESS: 'Rule enabled',
  DISABLED_SUCCESS: 'Rule disabled',
  SAVE_ERROR: 'Unable to save. Please retry.',
  LOAD_ERROR: 'Unable to load. Please retry.',
  EVENT: 'Trigger event',
  CHANNEL: 'Channel',
  IN_APP: 'In-app notification',
  COOLDOWN: 'Reminder interval',
  VERSION: 'Rule version',
  MINUTES: '{count} minutes',
  CLOSE: 'Close',
  TOTAL: '{count} records',
  MESSAGE: 'Reminder message',
  MESSAGE_SEARCH: 'Search message, business ID or rule name',
  SEND_STATUS: 'Delivery',
  READ_STATUS: 'Read status',
  HANDLE_STATUS: 'Handling',
  SENT_AT: 'Sent at',
  PENDING_SEND: 'Pending delivery',
  SENT: 'Delivered',
  FAILED: 'Failed',
  UNREAD: 'Unread',
  READ: 'Read',
  PENDING: 'Pending',
  HANDLED: 'Handled',
  MESSAGE_NOTE: 'Read and handling states are recorded per recipient.',
  MARK_READ: 'Mark read',
  MARK_HANDLED: 'Mark handled',
  NO_MESSAGES: 'No reminder messages',
  MESSAGE_DETAILS: 'Message details',
  SOURCE: 'Business object',
  HISTORY: 'Message history',
  GENERATED: 'Reminder generated',
  MARK_SUCCESS: 'Message state updated',
  PARTIAL: '{count} messages could not be updated. Please retry.',
};

export const smartRemindersChinese = {
  EMPTY: '—',
  MODULE: '智能提醒',
  RULES: '提醒规则',
  MESSAGES: '消息列表',
  ALL: '全部',
  ALL_RULES: '全部规则',
  RULE_NAME: '规则名称',
  CONDITION: '触发条件',
  RECIPIENT: '接收人',
  LAST_TRIGGER: '最近触发',
  STATUS: '状态',
  ACTIONS: '操作',
  ENABLED: '已开启',
  DISABLED: '已关闭',
  RULE_SEARCH: '搜索规则名称或触发条件',
  SCENE: '业务场景',
  QUERY: '查询',
  RESET: '重置',
  REFRESH: '刷新',
  RETRY: '重试',
  RULES_NOTE: '提醒规则由系统预置，新增规则默认关闭，可通过开关开启或关闭。',
  NO_RULES: '暂无提醒规则，新增后默认关闭',
  NO_MATCH: '没有符合条件的规则',
  DETAILS: '规则详情',
  VIEW_MESSAGES: '查看消息',
  SWITCH_HINT: '关闭后停止生成该规则的新提醒，历史消息保留',
  ADMIN_ONLY: '仅管理员可以开启或关闭规则',
  RULE_SWITCH: '{name}：开启或关闭规则',
  ENABLED_SUCCESS: '规则已开启',
  DISABLED_SUCCESS: '规则已关闭',
  SAVE_ERROR: '保存失败，请重试',
  LOAD_ERROR: '加载失败，请重试',
  EVENT: '触发事件',
  CHANNEL: '提醒渠道',
  IN_APP: '站内通知',
  COOLDOWN: '提醒间隔',
  VERSION: '规则版本',
  MINUTES: '{count} 分钟',
  CLOSE: '关闭',
  TOTAL: '共 {count} 条',
  MESSAGE: '提醒消息',
  MESSAGE_SEARCH: '搜索消息、业务编号或规则名称',
  SEND_STATUS: '发送状态',
  READ_STATUS: '阅读状态',
  HANDLE_STATUS: '处理状态',
  SENT_AT: '发送时间',
  PENDING_SEND: '待发送',
  SENT: '已发送',
  FAILED: '发送失败',
  UNREAD: '未读',
  READ: '已读',
  PENDING: '待处理',
  HANDLED: '已处理',
  MESSAGE_NOTE: '每位接收人独立记录阅读和处理状态',
  MARK_READ: '标记已读',
  MARK_HANDLED: '标记已处理',
  NO_MESSAGES: '暂无提醒消息',
  MESSAGE_DETAILS: '消息详情',
  SOURCE: '业务对象',
  HISTORY: '消息记录',
  GENERATED: '生成提醒',
  MARK_SUCCESS: '消息状态已更新',
  PARTIAL: '有 {count} 条消息更新失败，请重试',
};
